import React, { useState, useEffect, useCallback } from "react";
import { Container, Box, Avatar } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  IconButton,
  CircularProgress
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Settings as SettingsIcon,
  AccountCircle,
  Storage,
  ColorLens,
  Business,
  Close,
  KeyboardArrowRight,
  InvertColors, Translate as TranslateIcon
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";
import { AdminService, Validator,Permissions } from "./../../../utils/web_config";

import LanguageToggle from "../../../utils/languagetoggle";

import Format from "date-fns/format";
import { useSnackbar } from "notistack";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function Settings(props) {
  const classes = useStyles();
  const history = useHistory();

  const [accountData, setAccountData] = useState({});


  const [passwordData, setPasswordData] = useState({
    open: false,
    loading: false,
    saving: false,
  })

  const [languageData, setLanguageData] = useState({
    open: false,
    loading: false,
    saving: false,
  })

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [passwordOld, setOld] = useState({ value: "", error: "" })
  const [passwordNew, setNew] = useState({ value: "", error: "" })
  const [passwordConfirmNew, setConfirmNew] = useState({ value: "", error: "" })


  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    if(history.location.state?.open){
      setPasswordData({...passwordData,open:true})
    }
  }, []);
  ///////////////////

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }

    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };
  /////////////
  const onOldChange = (event) => { if (event.target.value === "") { setOld({ value: '', error: <Translate>{({ translate }) => translate('settings.forms.hints.password_old')}</Translate> }) } else { setOld({ value: event.target.value, error: "" }); } };
  const onNewChange = (event) => { if (event.target.value === "") { setNew({ value: '', error: <Translate>{({ translate }) => translate('settings.forms.hints.password_new')}</Translate> }) } else { setNew({ value: event.target.value, error: "" }); } };
  const onConfirmNewChange = (event) => { if (event.target.value === "") { setConfirmNew({ value: '', error: <Translate>{({ translate }) => translate('settings.forms.hints.password_confirm_new')}</Translate> }) } else { setConfirmNew({ value: event.target.value, error: "" }); } };

  const onChangeClick = () => {
    if (passwordOld.value === "") {
      setOld({ value: "", error: <Translate>{({ translate }) => translate('settings.forms.hints.password_old')}</Translate> })
    } else if (passwordNew.value === "") {
      setNew({ value: "", error: <Translate>{({ translate }) => translate('settings.forms.hints.password_new')}</Translate> })
    } else if (passwordConfirmNew.value === "") {
      setConfirmNew({ value: "", error: <Translate>{({ translate }) => translate('settings.forms.hints.password_confirm_new')}</Translate> })
    }
    else if (passwordNew.value != passwordConfirmNew.value) {
      setConfirmNew({ value: passwordNew.value, error: <Translate>{({ translate }) => translate('settings.forms.hints.password_not_match')}</Translate> })
    }
    else { changePassword() }
  }

  const handleLanguageClose = (code) => {
    // setLang(code);
    // window.localStorage.setItem("lang", code);
    // setLanguageOpen(false);

  };
  ///////////////////////////////

  const changePassword = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );


    setPasswordData({ ...passwordData, saving: true });

    var data = {
      "new_password": passwordNew.value,
      "old_password": passwordOld.value
    }

    console.log("changing pass .....");

    createInstance
      .put(new AdminService().CHANGE_PASSWORD, data)
      .then(function (response) {
        setPasswordData({ ...passwordData, saving: false, open: false });
        var d = response.data;


        // clearUserInfo();

        notify("success", response.data.message);
      })
      .catch(function (error) {
        setPasswordData({ ...passwordData, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      <Dialog
        open={passwordData.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        onClose={() => setPasswordData({ ...passwordData, open: false })}
      >
        <DialogTitle id="alert-dialog-title">Change your password</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size='small'
                    variant='outlined'
                    color='primary'
                    type='password'
                    value={passwordOld.value}
                    placeholder={translate(
                      'settings.forms.hints.password_old'
                    )}
                    label={
                      <Translate id='settings.forms.labels.password_old' />
                    }
                    fullWidth
                    onChange={onOldChange}
                    helperText={passwordOld.error}
                    error={passwordOld.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size='small'
                    variant='outlined'
                    color='primary'
                    type='password'
                    value={passwordNew.value}
                    placeholder={translate(
                      'settings.forms.hints.password_new'
                    )}
                    label={
                      <Translate id='settings.forms.labels.password_new' />
                    }
                    fullWidth
                    onChange={onNewChange}
                    helperText={passwordNew.error}
                    error={passwordNew.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size='small'
                    variant='outlined'
                    color='primary'
                    type='password'
                    value={passwordConfirmNew.value}
                    placeholder={translate(
                      'settings.forms.hints.password_confirm_new'
                    )}
                    label={
                      <Translate id='settings.forms.labels.password_confirm_new' />
                    }
                    fullWidth
                    onChange={onConfirmNewChange}
                    helperText={passwordConfirmNew.error}
                    error={passwordConfirmNew.error !== ""}
                  />
                )}
              </Translate>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setPasswordData({ ...passwordData, open: false });
            }}
            variant="outlined"
            color="primary"
          >
            <Translate id="agents.forms.buttons.cancel" />
          </Button>
          <Button
            disabled={passwordData.saving}
            variant="contained"
            color="primary"
            onClick={onChangeClick}
            disableElevation
          >
            {passwordData.saving ? (
              <CircularProgress size={23} />
            ) : "Change"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* ///////////////////////////////////// */}

      <Dialog
        open={languageData.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        onClose={() => setLanguageData({ ...languageData, open: false })}
      >
        <DialogTitle id="alert-dialog-title">Choose preffered language</DialogTitle>
        <DialogContent>

          <LanguageToggle close={handleLanguageClose} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setLanguageData({ ...languageData, open: false });
            }}
          
            color="primary"
          >
            <Translate id="agents.forms.buttons.cancel" />
          </Button>
        </DialogActions>
      </Dialog>

      {/* //////////////////////////////// */}
      <Box display="flex">
        <Box mr={2}>
          {" "}
          <SettingsIcon color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>System settings</b>
        </Typography>
      </Box>
      <Grid container spacing={1} justify="center">
        <Grid item xs={12}>
          <Box m={2}>
            <Typography>You can change system settings here</Typography>
          </Box>
        </Grid>
       
        <Grid item xs={12} md={6}>
          <Box m={2} display='flex' width={1} justifyContent='center' alignItems='center' flexDirection='column'>
            <Avatar style={{height:120,width:120}}/>
            <Box mt={2}>
          <Typography gutterBottom variant='h5' align='center'>{accountData.first_name+" "+accountData.last_name}</Typography>
            <Typography color='textSecondary' align='center'>{accountData.user_type+" | "+accountData.role_name}</Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={7}>
          <CardActionArea
            onClick={() => {
              setPasswordData({ ...passwordData, open: true })
            }}
          >
            <Paper className={classes.paper} elevation={0}>
              <Box display="flex" alignItems="center" width={1}>
                <Box mr={2}>
                  <AccountCircle fontSize="large" />
                </Box>
                <Box flexGrow={1}>
                  <Typography>Change your password</Typography>
                </Box>
                <KeyboardArrowRight />
              </Box>
            </Paper>
          </CardActionArea>
        </Grid>
      <Permissions permissions="CAN_VIEW_CENTRIKA_ORGANIZATION">  <Grid item xs={12} md={7}>
          <Paper className={classes.paper} elevation={0}>
            <Box display="flex" alignItems="center" width={1}>
              <Box mr={2}>
                <Business fontSize="large" />
              </Box>
              <Box flexGrow={1}>
                <Typography>Centrika organization</Typography>
              </Box>
              <KeyboardArrowRight />
            </Box>
          </Paper>
        </Grid>
        </Permissions>
        <Permissions permissions="CAN_VIEW_SERVICE_REGISTRY"> 
        <Grid item xs={12} md={7}>
          <CardActionArea
            onClick={() => {
              history.push("/centrika/settings/services");
            }}
          >
            <Paper className={classes.paper} elevation={0}>
              <Box display="flex" alignItems="center">
                <Box mr={2}>
                  <Storage fontSize="large" />
                </Box>
                <Box flexGrow={1}>
                  <Typography>Services registry and discovery</Typography>
                </Box>
                <KeyboardArrowRight />
              </Box>
            </Paper>
          </CardActionArea>
        </Grid>
        </Permissions>
        <Grid item xs={12} md={7}>
          <Paper className={classes.paper} elevation={0}>
            <Box display="flex" alignItems="center">
              <Box mr={2}>
                <ColorLens fontSize="large" />
              </Box>
              <Box flexGrow={1}>
                <Typography>System theme</Typography>
              </Box>
              <KeyboardArrowRight />
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={7}>
          <Paper className={classes.paper} elevation={0}>
            <Box display="flex" alignItems="center">
              <Box mr={2}>
                <InvertColors fontSize="large" />
              </Box>
              <Box flexGrow={1}>
                <Typography>Primary color</Typography>
              </Box>
              <KeyboardArrowRight />
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={7}>
          <CardActionArea
            onClick={() => {
              setLanguageData({ ...languageData, open: true })
            }}
          >
            <Paper className={classes.paper} elevation={0}>
              <Box display="flex" alignItems="center">
                <Box mr={2}>
                  <TranslateIcon fontSize="large" />
                </Box>
                <Box flexGrow={1}>
                  <Typography>System language</Typography>
                </Box>
                <KeyboardArrowRight />
              </Box>
            </Paper>
          </CardActionArea>
        </Grid>
      </Grid>
    </div>
  );
}

export default withLocalize(Settings);
